import React, { Component } from "react";
import "./common/print.css";
import { Card, CardBody, CardHeader, Modal, Button, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import Axios from "axios";
import ReactToPrint from "react-to-print";
import { configuration } from "../appConfig";
import { calculatePrice } from "../pricing/calculatePrice";
import { connect } from "react-redux";
import ScrollToTop from "./common/ScrollToTop";
import "./dnsReportPrintMode.css"
import "./dnsReport.css"
import "./dnsReportResponsive.css"
import CarSvgSwiss from "../carbodyparts/CarSvgSwiss";
import connectDATSWISS from "./DAT/importDatSWISS";
import { updateJsonData } from "../redux/actions/updateJsonData";
import ReportFooter_Swiss from "./common/ReportFooter_Swiss";
import ReportHeader_Swiss from "./common/ReportHeader_Swiss";
import AllReportScanImages from "./common/AllReportScanImages";
import Spinner from "../spinner/index";
import { token } from "../appTokenConfig";
import SwissFullReportAuthorization from "./common/SwissFullReportAuthorization";
import NewpolandPriceTable from "./common/NewpolandPriceTable";
import Newswiss_CustomerInfoTable from "./common/newswiss_CustomerInfoTable";
import axios from "axios";

function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

class PolandReportFull extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: "",
      order: {
        vinNumber: "",
        orderNumber: Math.round(Math.random() * 100000000),
        issuedOn: new Date(),
      },
      partDetails: null,
      twoDView: true,
      vinNumber: null,
      vinfolderList: [],
      showTwoDView: true,
      selectedPartInfo: [],
      scanresult: [],
      imgTypeReport: true,
      swissTable: [],
      words: {},
      lang: "gb",
      Authorized: false,
      deAuthLoading: false,
      loading: false,
      jsonData: {},
      FullReportAuthorized: false,
      isFullReportAuthorizedKeyExists: false,
      modal: false,
      name: "",
      error: [],
      id: "",
      modal_dents: false,
      TotalDentCount: "",
      modal_Auth: false,
      PreDamage: "",
      downloadingZipfile: false,
      downloadProgress: 0,
      ReportGenerated: "",
      imageLoading: true,
      isAnyOnecheck: false,
      isShowReplaceColumn: false,
    };
    this.setImageLoading = this.setImageLoading.bind(this);
  }

  count = [];
  pageLanguage = {
    ch: "Seite",
    fr: "Page",
    en: "Page",
  };
  pageOfLanguage = {
    ch: "von",
    fr: "de",
    en: "of",
  };

  setImageLoading(loading) {
    this.setState({ imageLoading: loading });
  }

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let obj = {}
    if (nextProps.fullData) {
      obj.Authorized = nextProps.fullData.Authorized
      obj.fullData = nextProps.fullData
    }
    if (nextProps.lang !== prevState.lang) {
      obj.lang = nextProps.lang
    }
    return Object.keys(obj).length ? obj : null;
  }

  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.fullData) {
      this.setState({
        Authorized: nextProps.fullData.Authorized,
        fullData: nextProps.fullData
      })
    }
  }

  async componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    await this.getData(selectedFile);
    this.vinFolderList();
    this.getFallbackDetails();
    this.getLang();
  }

  getFallbackDetails = async () => {
    try {
      const url =
        configuration.getFallbackDetails +
        `?partner_id=${localStorage.getItem("partnerId")}`;
      const res = await axios.get(url);
      if (res.data) {
        this.setState({
          isShowReplaceColumn: parseInt(res.data.is_show_replace_column) === 1 ? true : false,
        });
      }
    } catch (error) {
      this.setState({
        isShowReplaceColumn: false,
      });
    }
  };

  getData = async (selectedFile) => {
    Axios.get(
      `${configuration.getData}?vin=${selectedFile}&partnerId=${localStorage.getItem("partnerId")}`
    ).then((r) => {
      this.setState({
        Authorized: r.data.Authorized ? r.data.Authorized : false,
        id: r.data.Authorized ? r.data.DriveThrough == "1" ? "drive_in" : "drive_through" : "",
        ReportGeneratedStatus: r.data.hasOwnProperty('ReportGeneratedStatus') ? r.data.ReportGeneratedStatus : 'FAIL',
        jsonData: r.data,
        FullReportAuthorized: r.data.FullReportAuthorized,
        isFullReportAuthorizedKeyExists: r.data.hasOwnProperty("FullReportAuthorized"),
        TotalDentCount: r.data.TotalDentCount ? r.data.TotalDentCount : "0",
        PreDamage: r.data.PreDamage,
        ReportGenerated: r.data.ReportGenerated,
        name: r.data.AuthorizedName,
        customerCompany: r.data.CustomerCompany ? r.data.CustomerCompany : '',
      }, () => {
        this.showWarningMessageForZurich()
        this.checkStatus()
      })
    }).catch(error => alert('An error occured please try again'));
  }

  checkStatus = () => {
    const { jsonData } = this.state;
    const isAnyOnecheck = jsonData && jsonData.Dents && jsonData.Dents.some(item => item.AE && item.AE.length > 0 || item.Ersetzen && item.Ersetzen.length > 0);
    this.setState({ isAnyOnecheck });
  }

  showWarningMessageForZurich = () => {
    const { customerCompany } = this.state;
    let zurichArr = ['zürich', 'zurich', 'zurigo', 'zurich', 'z%c3%bcrich+versicherung'];
    const isZurichClient = customerCompany ? zurichArr.includes(customerCompany.split(' ')[0].toLowerCase()) : false;
    if (isZurichClient) {
      Swal.fire({
        type: 'info',
        icon: 'info',
        title: this.lang('attention'),
        text: this.lang('zurichClientReportMessage'),
        confirmButtonText: 'OK',
        allowOutsideClick: false
      })
      .then((result) => {
        if (result.value) {
            if (this.props.history) {
                this.props.history.push('/DATswiss');
            } else {
                console.error('History is not defined');
            }
        }
    })
    .catch(error => {
        console.error('Error in Swal:', error);
    });
    }
  }
  // checkStatus = () => {
  //   const { jsonData } = this.state;
  //   const isAnyOnecheck = jsonData.Dents && jsonData.Dents.some(item => (item.Replacing && item.Replacing == true) || (item.Preprints && item.Preprints == true));
  //   if (isAnyOnecheck) {
  //     Swal.fire({
  //       type: 'info',
  //       icon: 'info',
  //       title: this.lang('attention'),
  //       text: this.lang('PleaseuseDATReportonly'),
  //       confirmButtonText: 'OK',
  //       allowOutsideClick: false
  //     })
  //       .then((result) => {
  //         if (result.value) {
  //           this.props.history.push('/DATswiss')
  //         }
  //       });
  //   }
  // }

  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };

  customerInfo = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
        "?partnerId=" +
        partnerId +
        "&vin=" +
        vin
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      }
    } else {
    }
  };

  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
        "?vin=" +
        selectedFile +
        "&partnerId=" +
        partnerId
      );

      // isScanListRecord START
      if (response.data[0]) {
        this.setState({
          isScanListRecord: response.data[0].isScanListRecord,
        });
      }
      // isScanListRecord END

      if (response.data[0] && response.data[0].resultTXT) {
        this.setState({
          vinfolderList: response.data,
          scanresult: response.data[0].resultTXT,
        });
        response.data[0].resultTXT.scanresult && this.countDetails(response.data[0].resultTXT.scanresult);
      }
    } else {
      this.props.history.push("/login");
    }
  };

  countDetails = async (rowArray) => {
    let promises = [];
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    for (let i = 0; i < rowArray.length; i++) {
      let url =
        configuration.GetPartDetails +
        "?vin=" +
        vin +
        "&partnerId=" +
        partnerId +
        "&part=" +
        rowArray[i].part;
      promises.push(Axios.get(url));
    }
    const arrRes = await Axios.all(promises);
    const ltgtdata = arrRes.map((result) => {
      let ltcount = 0;
      let gtcount = 0;
      let val = result.data && result.data.json.split("\r\n");
      val.map((r) => {
        let val2 = r.split(" ")[3];
        if (val2 && parseInt(val2) > 25) {
          gtcount = gtcount + 1;
        }
        if (val2 && parseInt(val2) < 26) {
          ltcount = ltcount + 1;
        }
        return val2;
      });
      return {
        part: result.data.part,
        count: val.length - 1,
        lt25: ltcount,
        gt25: gtcount,
        ltunit: calculatePrice(24, ltcount),
        gtunit: calculatePrice(26, gtcount),
      };
    });
    this.setState({ swissTable: ltgtdata });
  };
  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    this.customerInfo();
  };
  SizeDropdown = (size, index) => {
    const arr = [0, 10, 20, 30, 40, 50, 60, 70, 80];
    return (
      <select value={size} onChange={(e) => this.change(e.target.value, index)}>
        {arr.map((row, i) => (
          <option key={i}>{row}</option>
        ))}
      </select>
    );
  };
  change = (val, index) => {
    //
    const { scanresult } =
      this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT;
    scanresult[index].size = val;
    this.setState({ scanresult });
    const result = window.confirm("Are you sure want to change Size?");
    if (result) {
      const url = configuration.Update_ResultTxt;
      let payload = {
        scanresult: scanresult,
        partnerId: localStorage.getItem("partnerId"),
        vin: localStorage.getItem("selectedFile"),
      };
      Axios.post(url, payload).then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
      });
    }
  };
  handleChange = (row, value, index) => {
    if (value > 0) {
      row.size = value;
      this.setState({ dd: row });
    }
  };
  changeCount = (row, value, index) => {
    if (value >= 0) {
      row.Amount = value;
      this.setState({ countRow: row });
    }
  };
  Update = () => {
    const url = configuration.Update_ResultTxt;
    let data = this.state.vinfolderList[0].resultTXT;
    data.partnerId = localStorage.getItem("partnerId");
    Axios.post(url, data).then((res) => {
      alert("data updated");
    });
  };

  getUpdatedStateFromPriceTable = (fullData) => {
    this.setState({
      fullData: fullData
    })
  }

  downloadDAT = async () => {
    let vin = localStorage.getItem('selectedFile');
    let row = { vin: vin }
    this.setState({
      datLoading: true
    })
    let loader = await connectDATSWISS(row);
    this.setState({
      datLoading: loader,
    })
  }

  internalStatus = async (vin) => {
    const url = configuration.internalStatus;
    let payload = {
      vin: vin,
      status: 3,
    }
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    await Axios.post(url, payload, { headers })
  }

  authorize = async () => {
    this.setState({
      modal_Auth: true
    })
    const { id } = this.state;
    var driveinid = id === "drive_in" ? "1" : "0"
    const { fullData } = this.state
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url1 =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}`;

    this.setState({
      loading: true
    })
    let totalDents = 0;
    await fullData && fullData.Dents && fullData.Dents.length && fullData.Dents.map((row, i) => {
      if (row.Part === 'TrunkCover') {
        fullData.Dents[i]['A'] = fullData.Dents[i]['A'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'];
        fullData.Dents[i]['B'] = fullData.Dents[i]['B'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'];
        fullData.Dents[i]['C'] = fullData.Dents[i]['C'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'];
        fullData.Dents[i]['TotalDents'] = fullData.Dents[i]['A'] + fullData.Dents[i]['B'] + fullData.Dents[i]['C'];
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['TotalDents'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaMm'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaPx'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWa'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWb'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWc'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AW'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['Price'] = 0;
      }
      if (row.Part !== 'Trunk') {
        totalDents += (parseInt(row.A) ? parseInt(row.A) : 0) + (parseInt(row.B) ? parseInt(row.B) : 0) + (parseInt(row.C) ? parseInt(row.C) : 0);
      }
    })
    this.setState({
      fullData: { ...this.state.fullData, 'TotalDentCount': totalDents }
    }, async () => {

      let payload = {
        ...this.state.fullData,
        Authorized: true,
        FullReportAuthorized: false,
        AuthorizedName: this.state.name,
        DriveThrough: 1,
        ReportGenerated: true
      }
      const url = configuration.generatePDF;
      await Axios.post(url1, { ...fullData, Authorized: false, FullReportAuthorized: true, DriveThrough: driveinid, ReportGenerated: false, AuthorizedName: this.state.name, ReportGeneratedStatus: 'PENDING' })
        .then(async (res) => {
          await Axios.post(url, {
            partnerId,
            vin
          }).then((res) => {
            this.internalStatus(vin);
            this.state.fullData.Authorized = true
            if (res.data.status === 200) {
              this.setState({
                loading: false,
                Authorized: true, //for updating local state instantly
                FullReportAuthorized: true,
                isFullReportAuthorizedKeyExists: true,
                modal_Auth: false
              })
              Toast.fire({
                type: "success",
                title: "PDF generated successfully!",
              });
              this.props.updateJsonData(this.state.fullData);
            } else if (res.data.status === 500) {
              this.setState({
                loading: false,
                modal_Auth: false
              })
              // vin or partner Id missing
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
            } else {
              this.setState({
                loading: false,
                modal_Auth: false
              })
              Toast.fire({
                type: "error",
                title: "pdf generate failed",
              });
            }
            // alert("data updated");
          }).catch(err => {
            this.setState({
              loading: false,
              modal_Auth: false
            })
            Toast.fire({
              type: "error",
              title: "pdf generate failed",
            });
          });
        })
    })
  }
  authorizedrivethrough = async () => {
    this.setState({
      modal_Auth: true
    })
    const { id } = this.state;
    var driveinid = id === "drive_in" ? "1" : "0"
    const { fullData } = this.state
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url1 =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}`;

    this.setState({
      loading: true
    })
    let totalDents = 0;
    await fullData && fullData.Dents && fullData.Dents.length && fullData.Dents.map((row, i) => {
      if (row.Part === 'TrunkCover') {
        fullData.Dents[i]['A'] = fullData.Dents[i]['A'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'];
        fullData.Dents[i]['B'] = fullData.Dents[i]['B'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'];
        fullData.Dents[i]['C'] = fullData.Dents[i]['C'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'];
        fullData.Dents[i]['TotalDents'] = fullData.Dents[i]['A'] + fullData.Dents[i]['B'] + fullData.Dents[i]['C'];
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['TotalDents'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaMm'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaPx'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWa'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWb'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWc'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AW'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['Price'] = 0;
      }
      if (row.Part !== 'Trunk') {
        totalDents += (parseInt(row.A) ? parseInt(row.A) : 0) + (parseInt(row.B) ? parseInt(row.B) : 0) + (parseInt(row.C) ? parseInt(row.C) : 0);
      }
    })
    this.setState({
      fullData: { ...this.state.fullData, 'TotalDentCount': totalDents }
    }, async () => {
      const url = configuration.automated_scripts;
      let payload1 = {
        partnerId,
        vin,
        authorizer_name: this.state.name
      }
      await Axios.post(url1, { ...fullData, Authorized: false, FullReportAuthorized: true, DriveThrough: driveinid, ReportGenerated: false, AuthorizedName: this.state.name, ReportGeneratedStatus: 'PENDING' })
        .then(async (res) => {
          await Axios.post(url, payload1)
            .then(async (res) => {
              this.internalStatus(vin);
              this.state.ReportGenerated = false;
              this.state.fullData.Authorized = true
              if (res.status === 200) {
                this.setState({
                  loading: false,
                  Authorized: true, //for updating local state instantly
                  FullReportAuthorized: true,
                  isFullReportAuthorizedKeyExists: true,
                  modal_Auth: false
                })
                Toast.fire({
                  type: "success",
                  // title: "PDF generated successfully!",
                  title: this.lang("All reports are being generated. Please check All Scan Records page after sometime."),
                });

                this.props.updateJsonData(this.state.fullData);
              } else if (res.data.status === 500) {
                this.setState({
                  loading: false,
                  modal_Auth: false
                })
                // vin or partner Id missing
                Toast.fire({
                  type: "error",
                  title: "Something went wrong!",
                });
              } else {
                this.setState({
                  loading: false,
                  modal_Auth: false
                })
                Toast.fire({
                  type: "error",
                  title: "pdf generate failed",
                });
              }
            }).catch(err => {
            })
        }).catch(err => {
        })
    })
  }

  deAuthorize = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url1 =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}`;
    this.setState({
      deAuthLoading: true
    })
    this.state.fullData.Authorized = false
    this.state.id = ""
    let payload = {
      ...this.state.fullData,
      ...this.state.id,
      Authorized: false,
      FullReportAuthorized: false,
      ReportGenerated: false,
      AuthorizedName: this.state.name,
      ReportGeneratedStatus: 'PENDING'
    }
    Axios.post(url1, payload).then((res) => {
      Toast.fire({
        type: "success",
        title: "De-Authorize PDF successfully!",
      });
      this.setState({
        Authorized: false,
        deAuthLoading: false,
        FullReportAuthorized: false,
        id: "",
        ReportGeneratedStatus: "PENDING"
        // isFullReportAuthorizedKeyExists:true
      })
      this.props.updateJsonData(this.state.fullData);
    }).catch(err => {
      this.setState({
        deAuthLoading: false
      })
      alert("Table update failed");
    });
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSave = () => {
    const { name, id } = this.state;
    let error = [];
    if (name.trim() == "") {
      error.push("Please enter your name")
    }
    if (error.length) {
      this.setState({
        error: error,
        Modal: true
      })
    } else {
      this.setState({
        error: []
      })
    }
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (id == "drive_in") {
      const url = configuration.authorizernamestore + `?partnerId=${partnerId}&vin=${vin}&name=${name}&drive_type=${"drive_in"}`;
      Axios.post(url).then((res) => {
        if (res.data.status === 200) {
          if (!error.length) {
            window.history.pushState(null, "", window.location.href);
            window.onpopstate = function () {
              window.history.pushState(null, "", window.location.href);
            };
            this.authorize();
            this.setState({ modal: false, })
          }
        }
      })
    } else {
      if (!error.length) {
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = function () {
          window.history.pushState(null, "", window.location.href);
        };
        this.authorizedrivethrough();
        this.setState({ modal: false })
      }
    }

  }
  downloadReportZip = () => {
    this.setState({
      downloadingZipfile: true
    })
    let [partnerId, vin] = [localStorage.getItem('partnerId'), localStorage.getItem('selectedFile')]
    const { lang } = this.state
    let url = `${configuration.downloadReports}?partnerId=${partnerId}&vin=${vin}&lang=${lang}`
    Axios.get(url)
      .then((res) => {
        if (res.data.status === 200) {
          this.downloadFile(res.data.data, `${vin}.zip`)
            .then(() => {
              this.setState({
                downloadingZipfile: false,
                downloadProgress: 0
              })
              Toast.fire({
                type: "success",
                title: "Zip download successfully!",
              });
            }).catch((err) => {
              this.setState({
                downloading: false,
                downloadProgress: 0
              })
              Toast.fire({
                type: "error",
                title: "Something want wrong!",
              });
            })
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something want wrong!",
        });
      })
  }
  downloadFile = async (file, fileName) => {
    return new Promise((resolve, reject) => {
      if (file) {
        const options = {
          onDownloadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            this.setState({
              downloadProgress: Math.floor((loaded * 100) / total),
            });
          },
        };

        Axios.get(file, {
          responseType: "blob",
          ...options,
        }).then(function (response) {

          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          })
      } else {
        reject();
      }
    })
  }
  render() {
    const client = localStorage.getItem("client")
    const scanResult =
      this.state.vinfolderList.length && this.state.vinfolderList[0];
    scanResult.resultTXT && scanResult.resultTXT.scanresult &&
      scanResult.resultTXT.scanresult.filter((row) => {
        if (row.size) {
          let size = row.size - (row.size % 10);
          return (row.size = row.size % 10 >= 5 ? size + 10 : size);
        } else {
          return row;
        }
      });

    const { imageLoading, isShowReplaceColumn } = this.state
    const showErsetzenColumn = (client === "POLAND" || client === "POLAND_HAIL") ? isShowReplaceColumn : true;

    return (
      <div className="animated fadeIn">
        <div xs="12" sm="12" className="p-2">
          <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
                    <small> {client === "SWISS" || client === "POLAND" ? <span>{this.lang("DashboardVIN")} : </span> : <span>{this.lang("VIN Number")} : </span>} {localStorage.getItem("selectedFile")}</small>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      <SwissFullReportAuthorization />
                      <ReactToPrint
                        trigger={() => {
                          document.title = localStorage.getItem("selectedFile");
                          return (
                            <button className="btn btn-danger btn-lg">
                              <i className="fa fa-print" /> {this.lang("Print PDF")}
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <CardBody style={{ padding: 0 }}>
            <div
              className="container all-reports-top-wrapper swiss-report-wrapper"
              ref={(el) => (this.componentRef = el)}
              style={{ padding: 0 }}
              data-content-name={this.pageOfLanguage[this.state.lang]}
            >
              {!imageLoading ? (
                <>
                  <div id="front-page-card" className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                    <div className="col-sm-12 full-height-col col-zero">
                      <Card className="show-footer">
                        <CardBody className="col-zero">
                          <div className="newFormatReport_wrapper headerRow">
                            <ReportHeader_Swiss />
                            <Newswiss_CustomerInfoTable />
                            <NewpolandPriceTable getUpdatedStateFromPriceTable={(data) => this.getUpdatedStateFromPriceTable(data)} />
                          </div>
                        </CardBody>
                        <div id="report_page_one">
                          <ReportFooter_Swiss pageNo={1} reportType='newReportFull' />
                        </div>
                      </Card>
                    </div>
                  </div>

                  {(this.state.isAnyOnecheck && showErsetzenColumn) &&
                    <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                      <div className="col-sm-12 full-height-col col-zero">
                        <Card>
                          <CardBody className="col-zero">
                            <div className="newFormatReport_wrapper">
                              <ReportHeader_Swiss />
                              <NewpolandPriceTable is_extra_columns_visible_mini_fullreport={true} />
                              {/* <div className="p-0 row ">
                        </div> */}
                            </div>
                          </CardBody>
                          <ReportFooter_Swiss />
                        </Card>
                      </div>
                    </div>}
                  {/* CarSVG */}
                  {this.state.isScanListRecord == '0' &&
                    (
                      <div id="front-page-card-two" className="row row-zero page-break-row report-full-wrapper second-svg-section" data-content-name={this.lang("Page")}>
                        <div className="col-sm-12 full-height-col col-zero">
                          <Card className="show-footer">
                            <CardBody className="col-zero">
                              <div className="newFormatReport_wrapper">
                                <ReportHeader_Swiss />
                                <div className="container car-svg-main">
                                  <div className="row title-row-main">
                                    <div className="col-sm-12 col-zero">
                                      <h3 className="report-title">
                                        {this.lang("2D")}<span> {this.lang("View")}</span>{" "}
                                      </h3>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-sm-12 text-center">
                                      <CarSvgSwiss {...this.props} reportType='newReportFull' />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </CardBody>
                            <div id="report_page_two">
                              <ReportFooter_Swiss pageNo={2} reportType='newReportFull' />
                            </div>
                          </Card>
                        </div>
                      </div>
                    )
                  }
                </>
              ) : (
                <>
                  <Spinner />
                </>
              )}
              <AllReportScanImages imageLoading={this.state.imageLoading} setImageLoading={this.setImageLoading} />

            </div>
          </CardBody>
        </div>
        <div>
          <ScrollToTop />
        </div>
        <Modal isOpen={this.state.modal} className="authorizer_name_modal" backdrop="static"
          toggle={() => this.setState({ modal: false })}
        >
          <ModalHeader className="align-item-center">{this.lang("Authorizer name")}</ModalHeader>
          <ModalBody>
            <form>
              <div className="form_group">
                <input className="form-control" placeholder={this.lang("Authorizer name")} type="text"
                  name="name"
                  value={this.state.name}
                  onChange={(e) => this.handleChange(e)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      this.handleSave()
                    }
                  }}
                />
                {this.state.error.includes('Please enter your name') && <span style={{ color: "red" }}>{this.lang("Please enter your name")}</span>}
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <div>
              <Button color="secondary" className="btn btn-md p-2 mr-2" onClick={() => this.setState({ modal: false })}> {this.lang("Cancel")} </Button>
              <Button color="secondary" className="btn btn-md p-2 btn-danger" onClick={() => this.handleSave()}> {this.lang("Save")} </Button>
            </div>
          </ModalFooter>
        </Modal>

        <Modal size="md" isOpen={this.state.modal_dents} className="dent_zero_modal" backdrop="static"
          toggle={() => this.setState({ modal_dents: false })}>
          <ModalBody className="text-center">
            <p className="mb-3 text-message-extra-image"><b>{this.lang("The total number of dents is 0. Would you still like to authorize.")}</b></p>
            <button className="btn btn-danger p-2 mr-2" onClick={() => this.setState({ modal: true, modal_dents: false })}> {this.lang("Yes")} </button>
            <button className="btn btn-cancel p-2" onClick={() => this.setState({ modal_dents: false })}> {this.lang("No")} </button>
          </ModalBody>
        </Modal>

        <Modal centered size="lg" isOpen={this.state.modal_Auth} className="authorise_modalpopup" backdrop="static"
          toggle={() => this.setState({ modal_Auth: false })}>
          <ModalBody className="text-center">
            <p className="mb-3 text-message-extra-image"><b>{this.lang("Please wait Authorization in progress")}<span className="dot-flashing"></span></b></p>
          </ModalBody>
        </Modal>

      </div>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    fullData: props.jsonData
  };
};
export default connect(mapStateToProps, {
  updateJsonData
})(PolandReportFull);
